<template>
  <section class="privileges">
    <p>Доступы</p>
    <div class="table__header">
      <mcw-textfield
        class="table__filter"
        outlined
        dense
        v-model="searchString"
        placeholder="Поиск"
        trailingIcon="search"/>
    </div>
    <div class="privileges__table">
      <table class="mdc-data-table__table">
        <thead>
          <tr class="mdc-data-table__header-row">
            <th class="mdc-data-table__header-cell">Договор</th>
            <th class="mdc-data-table__header-cell">Заказчик</th>
            <th class="mdc-data-table__header-cell">Исполнитель</th>
          </tr>
        </thead>
        <tbody class="mdc-data-table__content">
          <Spinner v-show="isLoading"/>
          <tr
            class="mdc-data-table__row"
            v-for="(item, index) in paginatedData"
            :key="index">
            <td class="mdc-data-table__cell table__cell">{{ item.contract }}</td>
            <td class="mdc-data-table__cell table__cell">{{ item.org_beneficial }}</td>
            <td class="mdc-data-table__cell table__cell">{{ item.org_doer }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <Pagination
      :pages="pages"
      :itemsPerPage="itemsPerPage"
      @selectPage="selectPage"
      @changeNumber="changeNumber"/>
  </section>
</template>

<script>
import PaginationMixin from './Pagination/paginationMixin';
import Pagination from './Pagination/Pagination.vue';
import Spinner from './Spinner.vue';

export default {
  name: 'Privileges',
  mixins: [
    PaginationMixin,
  ],
  components: {
    Pagination, Spinner,
  },
  data() {
    return {
      searchString: '',
      data: [],
      isLoading: false,
    };
  },
  computed: {
    privileges() {
      return this.data;
    },
    filteredData() {
      const search = this.searchString.trim().toLowerCase();
      if (!search.length) {
        return this.privileges;
      }
      const searchWords = search.split(/\s+/);
      return this.privileges.filter((item) => {
        const combined = Object.values(item).join(' ').toLowerCase();
        return searchWords.every((word) => combined.includes(word));
      });
    },
  },
  watch: {
    filteredData() {
      this.currentPage = 1;
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      this.data = await this.$store.dispatch('employeesData/getPrivilegesMap');
    } catch (error) {
      console.error('Error fetching privileges:', error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    changeNumber(number) {
      this.itemsPerPage = number;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss">
.privileges {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__table {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  // стили не scoped: без вложения в .privileges они применялись ко всем
  // .table__filter / .table__header приложения (поиск в договорах, таблицах пациентов и т.д.)
  & .table__filter {
    width: 500px;
  }

  & .table__header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}
</style>
